import React, { useEffect, useState } from 'react';
import { Droppable } from 'react-beautiful-dnd';

/**
 * Wrapper around react-beautiful-dnd Droppable that delays render
 * until after the first animation frame to work around StrictMode.
 */
const StrictModeDroppable = ({ children, ...props }) => {
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    const animation = requestAnimationFrame(() => setEnabled(true));
    return () => {
      cancelAnimationFrame(animation);
      setEnabled(false);
    };
  }, []);

  if (!enabled) return null;

  return <Droppable {...props}>{children}</Droppable>;
};

export default StrictModeDroppable;
